__turbopack_context__.v({
  "group": "text-stagger-module__-aK-EW__group",
  "item": "text-stagger-module__-aK-EW__item",
  "textStaggerFade": "text-stagger-module__-aK-EW__textStaggerFade",
  "textStaggerRise": "text-stagger-module__-aK-EW__textStaggerRise",
});
